<i18n src="../../locales/lang.json"></i18n>

<template>
  <div>
    <modal-default title="Manage file" ref="thisModal" style="z-index:1301" v-bind:onsave="doSave" v-bind:buttontext="$t('ok')" v-bind:class="'pasteTarget'+getId()">
      <div class="container-fluid upload-container p-0 skin light-bg mb-3">
        <ul class="nav nav-tabs  nav-tabs-highlight skin light-bg mb-0" id="uploadTabs">
          <li class="nav-item" style="">
            <a v-bind:href="'.uploadPanel' + getId()" class="nav-link active show" data-toggle="tab">
              {{$t('new_file')}}
            </a>
          </li>
          <li class="nav-item">
            <a @click="loadFiles" v-bind:href="'#libraryPanel' + getId()" class="nav-link" data-toggle="tab">
              {{$t('media_library')}}
            </a>
          </li>
          <li class="nav-item">
            <a v-bind:href="'#externalLinkPanel' + getId()" class="nav-link" data-toggle="tab">
              {{$t('external_link')}}
            </a>
          </li>
          <li class="nav-item" id="propertiesTab">
            <a @click="loadFile" v-bind:href="'#propertiesPanel' + getId()" class="nav-link" data-toggle="tab">
              {{$t('file_properties')}}
            </a>
          </li>
        </ul>

        <div class="row">
          <div class="col pt-0">
            <div class="card tab-content border-top-0 rounded-top-0 mb-0 p-3 border-iprocedo shadow-0" style="background-color:transparent;">
              <div class="tab-pane fade show active" v-bind:class="'uploadPanel' + getId()">
                <upload-file-selector2 ref="uploader"  v-bind:uid="uid" @change="fileuploaded"></upload-file-selector2>
                <div v-show="false" class="row pt-2" v-bind:class="'uploadPanel' + getId()">
                  <div class="col-1">
                    <input-checkbox id="saveInLib" @input="setSaveInLib" v-bind:checked="saveInLibrary"></input-checkbox>
                  </div>
                  <div class="col-11">
                    <span>
                      {{ $t('save_in_library') }}
                    </span>
                  </div>
                </div>
              </div>
              <div v-bind:id="'libraryPanel' + getId()" class="tab-pane fade">
                <upload-file-lib ref="medialib" v-bind:uid="uid" @change="fileSelected"></upload-file-lib>
              </div>
              <div v-bind:id="'externalLinkPanel' + getId()" class="tab-pane fade">

                <div class="row">
                  <div class="col-12">
                    {{$t('link_to_external_file_or_page')}}
                  </div>
                  <div class="col-12 mt-1">
                    <input class="form-control" @change="changeLink" type="text" placeholder="https://..." v-model="link" />
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mt-3">
                    <flickr-button @onclicked="onflickerclicked"></flickr-button>
                    <pexels-button @onclicked="onflickerclicked"></pexels-button>
                    <dall-e-button @onclicked="onflickerclicked"></dall-e-button>
                  </div>
                </div>

              </div>
              
              <div v-bind:id="'propertiesPanel' + getId()" class="tab-pane fade">
                <upload-file-properties ref="uploadFileProperties"></upload-file-properties>
              </div>
            </div>
            
          </div>
        </div>
      </div>
    </modal-default>
  </div>
 
</template>

<script>
  import ModalDefault from "../modals/modal-default.vue";
  import UploadFileSelector2 from "./upload-file-selector2.vue";
  import UploadFileLib from "./upload-file-lib.vue";
  import UploadFileProperties from "./upload-file-properties.vue";
  var saveInLibrary = false;
  var showAllFiles = false;
  var uploadedFileUrl = null;
  var uploadedFileName = null;
  var selectedFileUrl = null;
  var selectedFileName = null;
  var settings;

export default {
  name: "upload-container",
  components: {
    ModalDefault,
    UploadFileSelector2,
    UploadFileLib,
    UploadFileProperties
  },
  props: {
    state: {
      required: false,
      type: String,
      default: "closed"
    },
    uid: {
      required: false,
      type: String,
      default: null
    },
  },
  data() {
    return {
      saveInLibrary,
      showAllFiles,
      uploadedFileUrl,
      uploadedFileName,
      selectedFileUrl,
      selectedFileName,
      link : null,
      settings
    };
  },

 methods: {
   onflickerclicked(image) {
     //this.link = image.url_n;
     //alert("onflickerclicked:" + JSON.stringify(image))
     this.uploadFromUrl(image.url_n, image.title);
     //this.changeLink();
   },
   changeLink() {
      this.selectedFileName = this.link;
      this.selectedFileUrl = this.link;
      this.uploadedFileUrl == null
      this.uploadedFileName == null
    },
   open() {
      this.$refs.uploader.reset();
      this.$refs.uploader.setIsOpen(true);
      this.$forceUpdate();
      this.$refs.thisModal.open();
    },
    doSave() {
      if (this.selectedFileUrl == null &&
        this.selectedFileName == null &&
        this.uploadedFileUrl == null &&
        this.uploadedFileName == null)
        return;

      var url = this.uploadedFileUrl;
      var name = this.uploadedFileName;
      if (this.selectedFileUrl != null) {
        url = this.selectedFileUrl;
        name = this.selectedFileName;
      }
      this.$emit('change', url, name, this.settings);
      this.$forceUpdate();
      this.$refs.uploader.setIsOpen(false);
      
      this.$refs.thisModal.close();
    },
    handleRefresh(val) {
      this.$forceUpdate();
    },
    setSaveInLib(val) {
      this.saveInLibrary = val;
      if (this.saveInLibrary == true) {
        this.$refs.medialib.setUid(null);
        this.$refs.uploader.setUid(null);
        this.$refs.uploader.setSaveInLibrary(true);
      }
      else {
        this.$refs.medialib.setUid(this.uid);
        this.$refs.uploader.setUid(this.uid);
        this.$refs.uploader.saveInLibrary(false);
      }
      this.$refs.medialib.loadFiles();
    },
    async uploadFromUrl(url, name) {
        const headers = new Headers();
        const request = new Request(
          "/api/Upload/UploadWithUrl?url=" + url + "&categoryid=" + this.categoryid + "&name=" + name,
          {
            method: "GET",
            headers,
          }
        );
        const res = await fetch(request);
        var responseData = await res.json();
        this.link = responseData[0].url;
        this.changeLink();
        //var image = { url_n: responseData.url };
      var settings = {
        "Property": {  }
      }

      this.fileuploaded(responseData[0].url, responseData[0].name, settings);
        
      },
    fileuploaded(url, name, settings) {
      this.selectedFileUrl = null;
      this.selectedFileName = null;
      this.uploadedFileUrl = url;
      this.uploadedFileName = name;
      this.settings = settings;
      if (this.saveInLibrary) {
        this.$refs.medialib.loadFiles();
      }
    },
    fileSelected(url, name) {
      this.uploadedFileUrl = null;
      this.uploadedFileName = null;
      this.selectedFileUrl = url;
      this.selectedFileName = name;
      this.settings = this.getSettings(url);
    },
    getSettings(url) {
      //Property
      var settings = {
        "Property": [{ "mimetype": this.$refs.uploader(url) }]
      }
      return settings;
    },
    //selectFile() {
    //  this.$emit('change', response.data.url, response.data.name);
    //},
    clear() {
      this.selectedFileUrl = null;
      this.selectedFileName = null;
      this.uploadedFileUrl = null;
      this.uploadedFileName = null;
      this.saveInLibrary = false;
      this.link = null;
    },
    getId() {
      return this._uid;
    },
    loadFiles() {
      //alert('loloadFiles');
      this.$refs.medialib.loadFiles();
    },
    loadFile() {
      
      var url = this.uploadedFileUrl;
      var name = this.uploadedFileName;
      if (this.selectedFileUrl != null) {
        url = this.selectedFileUrl;
        name = this.selectedFileName;
      }

      this.link = url;

      this.settings = this.getSettings(url);

      this.$refs.uploadFileProperties.loadFile(url, name, this.settings);
    },
    showFile(url, name) {
      this.link = url;
      this.selectedFileUrl = url;
      this.selectedFileName = name;
      this.$refs.uploadFileProperties.loadFile(url, null);
      this.activateTab('#propertiesPanel' + this.getId());
    },
    activateTab(tab){
      $('#uploadTabs a[href="' + tab + '"]').tab('show');
    },
    handlePastedFile(results) {
      if (results.context.getIsOpen() == true) {
        results.context.handlePastedFile(results);
      }
    }
  }
  ,
  watch: {

  },
  mounted() {
    if (this.state == "open") {
      this.isopen = true
      this.open();
    }

    $(window).pasteImageReader(this.handlePastedFile, this.$refs.uploader);
  }
};
</script>

<style scoped>

  

  .border-iprocedo {
    border: 1px solid #ddd !important;
  }
  /*
  .nav-tabs-highlight .nav-link::before {
    top: 0px;
  }

  .nav-link {
    background-color: #f2f5f3 !important;
    border-left:1px solid #ddd !important;
    outline: none;
  }

  .nav-link.active {
    background-color: #fff !important;
  }

  .nav-item.active {
    color: #333 !important;
    background-color: #fff !important;
    border-color: #f2f5f3 #f2f5f3 #fff !important;
    border-top-width: 0px !important;
  }

  .nav-link::before {
    background-color: #f2f5f3 !important;
    height: 1px;
  }

  .nav-link.active::before {
    background-color: #ddd !important;
  }
      */


</style>



// WEBPACK FOOTER //
// src/components/upload/upload-container.vue